import React from 'react';
import Card from '../components/Widgets/Card';

const Home = (props) => {
  return (
    <div>

      <div className="pda-home-info">
        What's new in WPE
      </div>

      <div className="pda-home-card-1">
        <Card>
          <Card.Header>
            WPE Daily
          </Card.Header>
          <Card.Body>
            This is the body
          </Card.Body>
        </Card>
      </div>

      <div className="pda-home-card-2">
        <Card>
          <Card.Header>
            Latest Features
          </Card.Header>
          <Card.Body>
            <li> Feature 1 </li>
            <li> Feature 2 </li>
            <li> Feature 3 </li>
            <li> Feature 4 </li>
          </Card.Body>
        </Card>
      </div>

    </div>
  )
}

export default Home;
